<template>
  <div style="width: 100%">
    <!-- <template v-if="sort_by !== 'Step'"> -->
      <CollapsableCategory
        v-for="category in Object.keys(categorized_images)"
        :key="`gallery${category}`"
        :description="description || category"
        :color="foreground_color"
        :init_expanded="init_expanded === undefined ? true : init_expanded"
      >
        <!-- SLOT RIGHT BEFORE ARROW -->
        <template #header-middle>
          <slot name="header-middle"/>
        </template>

        <!-- ACTUAL CONTENT BELOW -->
        <template #content="{ is_collapsed, }">
          <TransitionAccordion>
            <Gallery
              v-if="!is_collapsed && layout === 'tiles'"
              :images="categorized_images[category]"
              :border_radius="5"
              @emittedClick="$emit('emittedClick', $event)"
            />
            <div v-if="!is_collapsed && layout === 'list'">
              <ClickableListItem
                v-for="image in categorized_images[category]"
                :key="`image-list-${image.id}`"
                :margin="2"
                :is_completely_clickable="true"
                :background_color="background_color"
                :foreground_color="foreground_color"
                @emittedClick="$emit('emittedClick', image)"
              >
                <template #front>
                  <img
                    class="work-package-image-list-front-slot"
                    :src="image.image"
                  />
                </template>

                <template #descriptor>
                  <div class="work-package-image-list-description">
                    <TText
                      :text="image.comment"
                      :color="foreground_color"
                      :size="8"
                      :line_height="1.4"
                      align="left"
                    />
                    <TText
                      :text="image.step
                        ? image.step.text
                        : 'WORK.package'
                      "
                      :color="foreground_color"
                      :size="8"
                      :line_height="1.4"
                      align="left"
                    />
                    <TText
                      :text="image.created.split(' UTC')[0]"
                      :color="foreground_color"
                      :size="8"
                      :line_height="1.4"
                      align="left"
                    />
                    <TText
                      :text="image.user"
                      :color="foreground_color"
                      :size="8"
                      :line_height="1.4"
                      align="left"
                    />
                  </div>
                </template>
              </ClickableListItem>
            </div>
          </TransitionAccordion>
        </template>
      </CollapsableCategory>
    <!-- </template> -->
    <!-- <template >
      <div>stepsimages</div>
    </template> -->
  </div>
</template>

<script>
import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import Gallery from '@/components/WorkPackageWIP/GalleryPhil.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';

import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import TText from '@/components/Taktify/TText.component.vue';

  export default {
    components: {
      CollapsableCategory,
      Gallery,
      TransitionAccordion,
      ClickableListItem,
      TText,
    },

    props: [
      'description', // is description for dropdown, only use this for hard description
      'categorized_images', // is array of objects, contains description, step, date, person (string)
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'sort_by',
      'layout',
      'init_expanded',
    ],

    computed: {

    },

    data: () => ({

    }),

    methods: {

    },
  }
</script>

<style>
  .work-package-image-list-front-slot {
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 5px;
  }
  .work-package-image-list-description {
     display: flex;
     flex-direction: column;
     pointer-events: none;
  }
</style>
